"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatEventListXL = exports.EventListXL = exports.flat = void 0;
const presentMultCheckboxReturn = (input, separator = ', ') => {
    const values = input.labels.filter((_, i) => input.values[i]);
    if ('otherSelected' in input && input.otherSelected) {
        values.push(input.otherValue);
    }
    const returnString = values.join(separator);
    return !!returnString ? returnString : '';
};
const flat = (input) => (input.length === 0 ? '' : input.join(', '));
exports.flat = flat;
const EventListXL = (events) => {
    let row = ['Event Information List'];
    let widths = [];
    const retVal = [];
    retVal.push(row);
    retVal.push(['This document was generated on: ', '', '', Date.now()]);
    retVal.push([]);
    row = [
        'Event Number',
        'Title           ',
        'Subtitle',
        'Type            ',
        'Meet Time       ',
        'Meet Location',
        'Start Time      ',
        'Event Location',
        'End Time        ',
        'Pickup Time     ',
        'Pickup Location',
        'Transportation Provided',
        'Transportation Description',
        'Comments',
        'Member Comments',
        'Activity Type',
        'Lodging Arrangement',
        'Event website',
        'High adventure description',
        'SMUniform',
        'CUniform',
        'Required participant forms',
        'Accept signups',
        'Meals',
        'Required Items',
        'Desired number of participants',
        'Event status',
        'Entry complete',
        'Show upcoming',
        'Administrative comments',
        'Custom Fields',
    ];
    widths = [...row.map(item => item.toString().length)];
    retVal.push(row);
    const evtid = [];
    for (const event of events) {
        row = [
            `${event.accountID}-${event.id}`,
            `${event.name}`,
            `${event.subtitle}`,
            `${event.type}`,
            event.meetDateTime,
            `${event.meetLocation}`,
            event.startDateTime,
            `${event.location}`,
            event.endDateTime,
            event.pickupDateTime,
            `${event.pickupLocation}`,
            `${event.transportationProvided ? 'Y' : 'N'}`,
            `${event.transportationDescription}`,
            `${event.comments}`,
            `${event.memberComments}`,
            `${presentMultCheckboxReturn(event.activity)}`,
            `${presentMultCheckboxReturn(event.lodgingArrangments)}`,
            `${event.eventWebsite}`,
            `${event.highAdventureDescription}`,
            `${presentMultCheckboxReturn(event.smuniform)}`,
            `${presentMultCheckboxReturn(event.cuniform)}`,
            `${presentMultCheckboxReturn(event.requiredForms)}`,
            `${event.acceptSignups ? 'Y' : 'N'}`,
            `${presentMultCheckboxReturn(event.mealsDescription)}`,
            `${exports.flat(event.requiredEquipment)}`,
            `${event.desiredNumberOfParticipants}`,
            `${event.status}`,
            `${event.complete ? 'Y' : 'N'}`,
            `${event.showUpcoming ? 'Y' : 'N'}`,
            `${event.administrationComments}`,
        ];
        for (const fieldName of event.customAttendanceFields) {
            row.push(fieldName.title);
        }
        evtid.push(event.id);
        retVal.push(row);
    }
    return [retVal, widths, evtid];
};
exports.EventListXL = EventListXL;
const FormatEventListXL = (sheet, columnMaxWidths, eventids, numRows, target) => {
    const dateFormat = 'yyyy-mm-dd hh:mm';
    const rowHeight = 13;
    sheet['!merges'] = [{ s: { c: 0, r: 0 }, e: { c: 4, r: 0 } }];
    sheet.D2.t = 'd';
    sheet.D2.z = dateFormat;
    const startrow = 5;
    sheet['!rows'] = [{ hpt: rowHeight }];
    let j = startrow;
    while (j <= numRows) {
        sheet[`A${j}`].l = { Target: `${target}${eventids[j - startrow]}` };
        sheet[`E${j}`].t = 'd';
        sheet[`E${j}`].z = dateFormat;
        sheet[`G${j}`].t = 'd';
        sheet[`G${j}`].z = dateFormat;
        sheet[`I${j}`].t = 'd';
        sheet[`I${j}`].z = dateFormat;
        sheet[`J${j}`].t = 'd';
        sheet[`J${j}`].z = dateFormat;
        j += 1;
    }
    sheet['!cols'] = columnMaxWidths.map(wch => ({ wch }));
    return sheet;
};
exports.FormatEventListXL = FormatEventListXL;
//# sourceMappingURL=EventListXlsx.js.map